// @flow
import { getTimezone, getTodayAsString } from '~/core/state/hub/selectors';

import { createSelector } from 'reselect';
import { fromJS } from 'immutable';
import { getIdFromProps } from '~/core/state/selectors';
import moment from 'moment-timezone';

const getState = state => state.motionSensor;

export const getHasLoaded = createSelector([getState, getIdFromProps], (sensor, id) => sensor.getIn([id, 'hasLoaded']));

export const getSelectedDay = createSelector([getState, getIdFromProps], (sensor, id) =>
    sensor.getIn([id, 'selectedDay'])
);

export const getSelectedDayAsMoment = createSelector([getSelectedDay, getTimezone], (selectedDay, timezone) =>
    moment.tz(selectedDay, timezone)
);

export const getHasDayDataLoaded = createSelector([getState, getIdFromProps], (sensor, id) =>
    sensor.getIn([id, 'hasLoadedDayData'], false)
);

export const getEvents = createSelector([getState, getIdFromProps], (sensor, id) =>
    sensor.getIn([id, 'events'], fromJS([]))
);

export const getSelectedDaysEvents = createSelector(
    [getSelectedDay, getEvents],
    (selectedDay, events) => (events ? events.get(selectedDay, fromJS([])) : fromJS([]))
);

export const getTodaysEvents = createSelector([getTodayAsString, getEvents], (today, events) =>
    events.get(today, fromJS([]))
);

export const getAllEvents = createSelector(
    [getEvents],
    events =>
        events
            ? fromJS(events.reduce((all, list) => [...all, ...list], []).sort((a, b) => a.start - b.start))
            : fromJS([])
);

// $FlowFixMe
export const getLastEvent = createSelector([getAllEvents], events => events.first() || fromJS({}));

export const getIsActive = createSelector([getLastEvent], event => event.get('inMotion', false));

export const getZoomLevel = createSelector([getState, getIdFromProps], (sensor, id) => sensor.getIn([id, 'zoomLevel']));

export const getEventsCurrentDay = createSelector([getState, getIdFromProps, getTodayAsString], (sensor, id, today) =>
    sensor.getIn([id, 'eventsCurrentDay'], today)
);

export const getEventsCurrentDayAsMoment = createSelector([getEventsCurrentDay, getTimezone], (currentDay, timezone) =>
    moment.tz(currentDay, timezone)
);



// WEBPACK FOOTER //
// ./src/core/state/products/motion-sensor/selectors.js